// extracted by mini-css-extract-plugin
module.exports = {"button":"likes_button__3aL1e","icon":"likes_icon__oQegu","iconFilled":"likes_iconFilled__e_Lyd"};